import { Box, FormLabel, Tooltip, IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import s from "../styles/ProductForm.module.scss";

export default function FieldLabel({ children, hint }) {
    return (
        <Box className={s.fieldLabelRow}>
            <FormLabel className={s.labelMuted}>{children}</FormLabel>
            {hint ? (
                <Tooltip title={hint} arrow>
                    <IconButton size="small" className={s.hintBtn} type="button">
                        <InfoOutlinedIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
            ) : null}
        </Box>
    );
}